/**
 * Rollen und Berechtigungen.
 *
 * Die Pruefung findet ausschliesslich serverseitig statt. Das Frontend nutzt
 * dieselben Definitionen nur, um Bedienelemente auszublenden — das ist
 * Bequemlichkeit, keine Sicherheitsmassnahme.
 */
export const ROLES = ['owner', 'admin', 'editor', 'viewer'];
/** Hoehere Zahl schliesst alle niedrigeren Rechte ein. */
const RANK = {
    viewer: 0,
    editor: 1,
    admin: 2,
    owner: 3,
};
export const PERMISSIONS = [
    'contacts:read',
    'contacts:write',
    'contacts:delete',
    'campaigns:read',
    'campaigns:write',
    'campaigns:send',
    'journeys:read',
    'journeys:write',
    'journeys:activate',
    'crm:read',
    'crm:write',
    'settings:read',
    'settings:write',
    'members:manage',
    'project:delete',
];
/** Mindestrolle je Berechtigung. */
const REQUIRED = {
    'contacts:read': 'viewer',
    'contacts:write': 'editor',
    'contacts:delete': 'admin',
    'campaigns:read': 'viewer',
    'campaigns:write': 'editor',
    'campaigns:send': 'admin',
    'journeys:read': 'viewer',
    'journeys:write': 'editor',
    'journeys:activate': 'admin',
    'crm:read': 'viewer',
    'crm:write': 'editor',
    'settings:read': 'admin',
    'settings:write': 'admin',
    'members:manage': 'admin',
    'project:delete': 'owner',
};
export function hasPermission(role, permission) {
    return RANK[role] >= RANK[REQUIRED[permission]];
}
export function permissionsFor(role) {
    return PERMISSIONS.filter((p) => hasPermission(role, p));
}
export function isRole(value) {
    return typeof value === 'string' && ROLES.includes(value);
}
//# sourceMappingURL=roles.js.map